import React, { createRef } from "react";
import { Radio } from "antd";
import { SectionStatusDiv } from "../../../../../../base/basicComponents/status/index";
import ReturnReasonHypelink from "../../../../../../base/basicComponents/returnReasonHypelink";
import { savedInRadioValues } from "../../../../../publicDictionaryValues";
import ApprovedSavedIn from "../approvedSavedIn";
import styles from "../index.module.scss";

const savedInReturnRef = createRef();
export default class ReadOnlyProcedureProcessSavedIn extends ApprovedSavedIn {
  render() {
    const { procedureSavedInRef } = this.props;
    const {
      procedureSaveInCategoryStatusID,
      isSavedInShowEditBtn,
      isSavedInError,
      savedInReturnReasonInputValue,
      savedInRadioValue,
    } = this.state.savedInSectionState;

    return (
      <div className={styles.procedureFileTop}>
        <div
          className={styles.procedureSavedIn}
          style={{ borderColor: isSavedInError ? "red" : "#b3b3b3" }}
          ref={procedureSavedInRef}
        >
          <div>
            <div className={styles.savedInTop} data-highlight-id="ProcedureSavedInType2">
              <div className={styles.procedureSaveInLabel}>Procedure Saved In:</div>
              <div className={styles.procedureSaveInChoice}>
                <Radio.Group
                  value={savedInRadioValue}
                  disabled={true}
                  data-testid="readonly-saved-in-radio-group"
                >
                  <Radio
                    value={savedInRadioValues.systemOnly}
                    data-testid="readonly-saved-in-system-only"
                  >
                    PMP System Only
                  </Radio>
                  <Radio
                    value={savedInRadioValues.systemAndClientServer}
                    data-testid="readonly-saved-in-system-and-server"
                  >
                    PMP System & Client Server
                  </Radio>
                  <Radio
                    value={savedInRadioValues.serverOnly}
                    data-testid="readonly-saved-in-server-only"
                  >
                    Client Server Only
                  </Radio>
                </Radio.Group>
              </div>
            </div>
          </div>
          <div className={styles.savedInContent} data-highlight-id="SavedInStatus">
            <div className={styles.statusBlock}>
              <div className={styles.statusLabel}>Status</div>
              <div className={styles.statusContent}>
                <SectionStatusDiv status={procedureSaveInCategoryStatusID} />
              </div>
            </div>
            <div className={styles.returnReasonBlock}>
              <div className={styles.returnReasonLabel}>Return Reason</div>
              <ReturnReasonHypelink
                inputRef={savedInReturnRef}
                value={savedInReturnReasonInputValue}
                isShowEditBtn={isSavedInShowEditBtn}
                isShowReasonLogIcon={this.props.savedInReturnReasonLog.length > 0}
                reasonLog={this.props.savedInReturnReasonLog}
              />
            </div>
            <div className={styles.actionBtns}></div>
          </div>
        </div>
      </div>
    );
  }
}
